<template>
  <div class="tech-dropdown">
    <div class="tech-dropdown-toggle">
      <a href="javascript:void(0);" @click="ddToggle">
        <i class="material-icons-outlined align-middle">more_horiz</i>
      </a>
    </div>
    <div class="tech-dropdown-menu" v-show="params.data.ddOpen">
      <ul>
        <li>
          <a href="javascript:void(0);" @click="editProject">
            <i class="material-icons align-middle">edit</i>
            Edit
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" @click="projectDetail">
            <i class="material-icons align-middle">inventory_2</i>
            Details
          </a>
        </li>
        <li>
          <a href="javascript:void(0);" @click="deleteProject">
            <i class="material-icons align-middle">delete</i>
            Delete
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isOpen() {
      return this.params.data.ddOpen;
    },
  },
  watch: {
    isOpen: function (val) {
      if (val) {
        let offset = this.$el.getBoundingClientRect();
        if (document.body.clientHeight - offset.top < 230) {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "auto";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "37px";
        } else {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "40px";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "auto";
        }
      }
    },
  },
  methods: {
    ddToggle: function () {
      this.params.data.ddOpen = !this.params.data.ddOpen;
      this.params.context.componentParent.openCurrentAgDropdown(
        this.params.data,
        this.$el
      );
    },
    editProject: function () {
      this.ddToggle();
      this.params.context.componentParent.editProject(this.params.data);
    },
    projectDetail: function () {
      this.ddToggle();
      const routeData = this.$router.resolve({
        path: "/home/admin/project_detail/" + this.params.data.index,
      });
      window.open(routeData.href, "_blank");
    },
    projectDetailPublic: function () {
      const routeData = this.$router.resolve({
        path: "/project_detail_public/" + this.params.data.index + "/allinfo",
      });
      window.open(routeData.href, "_blank");
    },
    deleteProject: function () {
      this.ddToggle();
      this.params.context.componentParent.deleteProject(this.params.data);
    },
  },
};
</script>
